<template>
  <div class="crumbs">
    <div class="content">
      <h4>{{ title }}</h4>
    </div>
    <slot name="close"></slot>
  </div>
</template>

<script>
export default {
  name: "crumbs",
  props: ["title"]
};
</script>

<style lang="less" scoped>
.crumbs {
  position: relative;
  margin-bottom: 10px;
  background: #fff;
  .content {
    box-sizing: border-box;
    height: 50px;
    padding: 10px 0 0 30px;
    h4 {
      height: 30px;
      padding-left: 15px;
      border-left: 3px solid #409eff;
      line-height: 30px;
      font-weight: normal;
    }
  }
  .close {
    position: absolute;
    top: 10px;
    right: 30px;
    line-height: 30px;
    font-size: 30px;
    color: #909399;
    cursor: pointer;
  }
}
</style>
